import type { UseStateType } from '~/types/utils/use-state-type'

// This is used to extract the right types from Nuxt useState
type Types = UseStateType<boolean>

/**
 * A type-safe wrapper around `useState`
 */
export const useLoggedInState = (init: Types['firstParam'] = undefined): Types['return'] =>
  useState<Types['state']>('loggedIn', init)

export function setLoggedInState(loggedIn: boolean): void {
  const loggedInState = useLoggedInState()
  loggedInState.value = loggedIn
}
